
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pristupnost",
      function () {
        return require("private-next-pages/pristupnost.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pristupnost"])
      });
    }
  